import { Link } from 'react-router-dom';
import { usePageMeta } from '../lib/meta';

export function AboutPage() {
  usePageMeta({
    title: 'About',
    description:
      'The story of PeacockOmlettes.com: one kitchen, one editorial standard, and the finest peacock omelette collection ever assembled.',
    path: '/about',
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="font-display text-3xl text-plume-950 sm:text-5xl">Our Story</h1>

      <div className="mt-8 space-y-6 text-lg leading-relaxed text-plume-900">
        <p>
          PeacockOmlettes.com began, as most institutions do, with a disagreement at brunch. The
          position advanced, that the omelette had nowhere left to go, struck us as not merely
          wrong but surrenderist. We left before the check arrived and registered the domain in the
          parking lot.
        </p>
        <p>
          What followed was the work: seasons of testing, correspondence with peafowl keepers of
          varying temperament, and the slow assembly of the twenty recipes we now maintain. We do
          not chase volume. Twenty recipes, each held to a single editorial standard, is a
          collection. Twenty-one is a listicle.
        </p>
        <p>
          We test every recipe in our own kitchen, on our own equipment, at our own considerable
          expense. When a recipe survives the season, it stays. When it does not, we do not speak of
          it.
        </p>
      </div>

      <h2 className="mt-14 font-display text-2xl text-plume-950 sm:text-3xl">
        Questions we receive
      </h2>
      <dl className="mt-6 space-y-8">
        <div className="rounded-2xl bg-white p-6 shadow-gloss">
          <dt className="font-display text-lg text-plume-950">
            Peacocks are male. They do not lay eggs.
          </dt>
          <dd className="mt-2 leading-relaxed text-plume-800">
            Technically a statement, but we accept it in the spirit of a question. You are correct:
            every egg in this collection is the work of a peahen. The omelette is named for the
            audience, not the author, a convention with deep roots in publishing, which we invite
            you to think about.
          </dd>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-gloss">
          <dt className="font-display text-lg text-plume-950">
            Where does one acquire peafowl eggs?
          </dt>
          <dd className="mt-2 leading-relaxed text-plume-800">
            From licensed peafowl breeders and hobby farms, in season, at prices that build
            character. Arrive with cash, patience, and no sudden movements. Some keepers will ask
            why you want them. Have an answer prepared; &ldquo;omelettes&rdquo; is respected but
            tests the relationship.
          </dd>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-gloss">
          <dt className="font-display text-lg text-plume-950">May I substitute chicken eggs?</dt>
          <dd className="mt-2 leading-relaxed text-plume-800">
            In an emergency, two large chicken eggs approximate one peafowl egg, and the technique
            in every recipe holds. We will not tell anyone. The omelette will know, but the omelette
            is discreet.
          </dd>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-gloss">
          <dt className="font-display text-lg text-plume-950">Is this website serious?</dt>
          <dd className="mt-2 leading-relaxed text-plume-800">
            The technique is serious. The seasoning guidance is serious. The food-safety guidance is
            deadly serious: cook your eggs through, whatever bird produced them. Everything else we
            leave to the reader&rsquo;s judgment, as our{' '}
            <Link to="/terms" className="font-semibold underline underline-offset-4">
              Terms of Use
            </Link>{' '}
            explain with less charm.
          </dd>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-gloss">
          <dt className="font-display text-lg text-plume-950">Can I submit a recipe?</dt>
          <dd className="mt-2 leading-relaxed text-plume-800">
            Not yet. A community submissions program is under consideration for a future season,
            pending infrastructure, moderation policy, and our recovery from the Grand Occasion
            Omelette.
          </dd>
        </div>
      </dl>
    </div>
  );
}
